import { bigPictureCta as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  header: 'E&V Blog',
  location: 'do I exist?',
  caption:
    'Peruse captivating articles featuring property insights, interior design, luxury living, Engel & Völkers news, vacation destinations, and more.',
  img: '/assets/textimageplaceholder.png',
  videoSrc: 'https://www.youtube.com/watch?v=oznr-1-poSU',
};

export default fakeProps(schema, TestData);
